import React from 'react';

import { Content } from './Content';
import s from './FormFilling.module.scss';

/**
 * Страница наполнения формы (загрузка excel 2 шаг)
 * @param basicFormStore
 * @constructor
 */
const FormFillingPage: React.FC = () => {
  return (
    <div className={s['form-filling__content']}>
      <Content />
    </div>
  );
};

export default FormFillingPage;
